export default __webpack_public_path__ + "static/media/undo.465b81c0.svg";